import SettingsApi from './SettingsApi';
export default SettingsApi;
